import api from './api';

export interface UserCredentialsResponse {
  status_code: number;
  message: string;
  data: {
    github_token: string | null;
    gitlab_token: string | null;
    github_org: string | null;
    gitlab_org: string | null;
    bitbucket_key: string | null;
    bitbucket_secret: string | null;
    bitbucket_workspace: string | null;
    bitbucket_project: string | null;
    azure_token: string | null;
    azure_org: string | null;
    azure_project: string | null;
    access_key: string | null;
    secret_key: string | null;
    s3_bucket: string | null;
  }
};

export interface UpdateCredentialsPayload {
  github_token?: string | null;
  gitlab_token?: string | null;
  github_org?: string | null;
  gitlab_org?: string | null;
  bitbucket_key?: string | null;
  bitbucket_secret?: string | null;
  bitbucket_workspace?: string | null;
  bitbucket_project?: string | null;
  azure_token?: string | null;
  azure_org?: string | null;
  azure_project?: string | null;
  access_key?: string | null;
  secret_key?: string | null;
  s3_bucket?: string | null;
}

export interface UpdateCredentialsResponse {
  status_code: number;
  message: string;
  data: unknown;
}

export const credsService = {
  fetchUserCredentials: async (): Promise<UserCredentialsResponse> => {
    try {
      const response = await api.get('/api/user/creds/fetch');
      return response.data;
    } catch (error) {
      console.error('Error fetching user credentials:', error);
      throw error;
    }
  },
  updateUserCredentials: async (
    payload: UpdateCredentialsPayload
  ): Promise<UpdateCredentialsResponse> => {
    try {
      const response = await api.put('/api/user/creds/update', payload);
      return response.data;
    } catch (error) {
      console.error('Error updating user credentials:', error);
      throw error;
    }
  }
};

